import React, { useEffect } from "react";
import * as s from "./Managers.styles";
import { useSelector, useDispatch } from "react-redux";
import * as actions from "../../../store/actions/index";

// shared
import Spinner from "../../../components/shared/spinner/Spinner";

// components
import ManagersComponent from "../../../components/admin/managers/ManagersComponent";

const Managers = () => {
  const dispatch = useDispatch();

  const ManagersLoading = useSelector((state) => state.forAdmins.loading);
  useEffect(() => {
    dispatch(actions.fetchAdmins(1, 10));
  }, []);

  return (
    <s.Container>
      {ManagersLoading === false ? (
        <s.ManagersContainer>
          <ManagersComponent showCreateManger={true} />
        </s.ManagersContainer>
      ) : (
        <s.SpinnerContainer>
          <Spinner />
        </s.SpinnerContainer>
      )}
    </s.Container>
  );
};

export default Managers;
